import {theme} from '@logistics-frontend/blocks/lpc/theme'
import {withStyles} from '@material-ui/core/styles'

import Dialog from './Dialog'

const AdaptiveDialog = withStyles(
  {
    container: {
      [theme.breakpoints.down('sm')]: {
        flexDirection: 'column-reverse',
        justifyContent: 'flex-start',
      },
    },
    paperFullWidth: {
      [theme.breakpoints.down('sm')]: {
        borderRadius: '16px 16px 0 0',
        height: 'auto',
        padding: '16px',
      },
    },
  },
  {name: 'LPCDialogActions'},
)(Dialog)

export default AdaptiveDialog
